'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const classNames = require('classnames')
const SmartyContent = require('../../shared/_layouts/_templates/_includes/smartyContent.jsx')
const Nav = require('../../shared/_layouts/_templates/_includes/nav.jsx')
const Breadcrumb = require('../../shared/_layouts/_templates/_includes/breadcrumb.jsx')
const { smartyIncludes, smartyVariables } = require('../../shared/_layouts/_templates/_includes/smartyIncludes.jsx')
const TrackerFix = require('../../shared/_layouts/_templates/_includes/trackerFix')
const Agents = require('../../_plugins/lib/agents')
const Helpers = require('../../_plugins/lib/helpers')
// const ExitDiscountModal = require('../../shared/_layouts/_templates/_includes/modals/ExitDiscountModal.jsx')
const getPhoneNumbers = require('../../_plugins/lib/phoneNumber')
const DiscountAlert = require('../../shared/_layouts/_templates/_includes/discount-alert.jsx')
const HarpAlert = require('../../shared/_layouts/_templates/_includes/harp-alert.jsx')
const { object } = require('prop-types')

const LandingPages = createReactClass({
  mixins: [Agents],

  propTypes: {
    domainSettings: object,
    settings: object,
    pageData: object.isRequired,
    agents: object,
    lastUpdated: object
  },

  componentDidMount () {
    const { pageData: { html } } = this.props
    let { agentData: { agent } } = this.state
    const { setVar } = smartyVariables(html)
    if (setVar.agent) {
      agent = setVar.agent
      this.checkAgent(agent, this.updateAgentData)
    }
    let environment = 'production'
    if (Helpers.getParameterByName('data-pipeline-staging')) environment = 'staging'
    if (Helpers.getParameterByName('data-pipeline-production')) environment = 'production'
    TrackerFix({
      agent,
      environment,
      templateGroup: 'core',
      schemaVersions: {
        cache_primer: 'v1.0.0',
        initialise: 'v1.1.0',
        auto_capture: 'v1.1.0',
        capture: 'v1.0.0',
        click: 'v1.0.0',
        focus: 'v1.0.0',
        ipseity: 'v1.0.0',
        load: 'v1.1.0',
        test: 'v1.0.0',
        view: 'v1.0.0'
      }
    })
    window.universalJavascriptLoaded = true
  },

  render () {
    const { agentData, phoneNumbers } = this.state
    const { agents: agentSettings, settings, pageData, domainSettings, lastUpdated: { updateddate } } = this.props
    const containerClass = classNames({
      'container-fluid': true
    })
    const { html } = pageData
    let { content } = smartyVariables(html)
    content = smartyIncludes(content)

    return (
      <div>
        <Nav agents={agentSettings} pageData={pageData} settings={settings} />
        <DiscountAlert settings={settings} agentData={agentData} />
        <HarpAlert domainSettings={domainSettings} settings={settings} />
        <div className={containerClass}>
          <div className='mainNav'>
            <ul className='nav nav-tabs'>
              <li><a href='/' title='Home'>Home</a></li>
              <li><a href='/airport-parking.html' title='Airport Parking'>Airport Parking</a></li>
              <li><a href='/airport-hotels.html' title='Airport Hotels'>Airport Hotels</a></li>
            </ul>
          </div>
          <Breadcrumb pageName={pageData.pageName} />
          <div className='row clearfix'>
            <div className='col-md-12 clearfix'>
              <SmartyContent domainSettings={domainSettings} settings={settings} agentData={agentData} pageData={pageData} theContent={content} phoneNumber={phoneNumbers.number} noSchemaMarkup lastUpdated={updateddate} />
            </div>
          </div>
        </div>
        {/* <ExitDiscountModal imageCloudSettings={imageCloudSettings} agentData={agentData} /> */}
      </div>
    )
  }
})

module.exports = getPhoneNumbers(LandingPages)



// WEBPACK FOOTER //
// ./_layouts/_templates/minimalLandingPages.jsx